"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeElementCheck = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var ThreeElementCheck = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ThreeElementCheck, _super);
    function ThreeElementCheck() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '三要素认证接口';
        _this.code = '106026';
        _this.desc = '三要素认证接口';
        _this.requestParams = new zl_1.ThreeElementCheckRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ThreeElementCheck;
}(service_1.BaseService));
exports.ThreeElementCheck = ThreeElementCheck;
//# sourceMappingURL=threeElementCheck.js.map